<template>
    <div class="new-order">
        <div class="header">
            <span class="title">{{$t('changePassword.changePassword')}}</span>
        </div>
        <div class="body password_form">
            <el-form ref="form" :model="form" :label-width="$isCurrentLang('en') ? '180px' : '120px'" style="width: 500px">
                <el-form-item :label="`${$t('changePassword.currentPassword')}：`">
                    <el-input v-model="form.oldPassword"
                              show-password
                              :placeholder="`${$t('changePassword.currentPasswordPlaceholder')}`"></el-input>
                </el-form-item>
                <el-form-item :label="`${$t('changePassword.newPassword')}：`">
                    <el-input v-model="form.newPassword"
                              show-password
                              :placeholder="`${$t('changePassword.newPasswordPlaceholder')}`"></el-input>
                </el-form-item>
                <el-form-item :label="`${$t('changePassword.confirmPassword')}：`">
                    <el-input v-model="form.confirmPassword"
                              show-password
                              :placeholder="`${$t('changePassword.confirmPasswordPlaceholder')}`"></el-input>
                </el-form-item>
                <div class="form-btn">
                    <el-button type="primary" @click="submit">{{$t('changePassword.submit')}}</el-button>
                    <el-button @click="close">{{$t('changePassword.close')}}</el-button>
                </div>
            </el-form>
            <!-- <div>
                <el-button type="primary" @click="submit">修改密码</el-button>
                <el-button @click="close">关闭</el-button>
            </div> -->
        </div>
    </div>
</template>

<script>
    import orderOperate from '../../mixins/order/common/OrderOperate';
    export default {
        mixins: [orderOperate],
        data() {
            return {
                form: {
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: '',
                }
            }
        },
        methods: {
            async submit() {
                if (this.form.newPassword.length < 6) {
                    this.$message.error(this.$t('changePassword.currentPasswordPlaceholder'));
                    return;
                }
                if (this.form.newPassword !== this.form.confirmPassword) {
                    this.$message.error(this.$t('changePassword.confirmPasswordMsg'));
                    return;
                }
                const { code } = await this.qPut(`/customer/wechat/customer/password/${this.form.oldPassword}/${this.form.newPassword}`);
                if (code === 200) {
                    this.$message.success(this.$t('changePassword.modifySuccessMsg'));
                    this.close();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .password_form {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .form-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        .el-button {
            width: 100px;
        }
    }
</style>